import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeProject: null,
  sourcesActiveNames: undefined,
  environmentActiveTypeIds: undefined,
  breedingSiteActiveTypeIds: undefined,
  smartTrapFilterIds: ['active', 'passive'],
  activeExtraLayers: [],
  smartTrapBufferInMeters: 600,
  gridSpacingInKilometers: 1,
}
sessionStorage.setItem('local-traps-buffer', JSON.stringify(600))
const login = createSlice({
  name: 'missionSetup',
  initialState,
  reducers: {
    setActiveProject: (state, action) => {
      state.activeProject = action.payload
    },
    setSourceActiveNames: (state, action) => {
      state.sourcesActiveNames = action.payload
    },
    setEnvironmentActiveTypeIds: (state, action) => {
      state.environmentActiveTypeIds = action.payload
    },
    setBreedingSiteActiveTypeIds: (state, action) => {
      state.breedingSiteActiveTypeIds = action.payload
    },
    toggleSmartTrapFilterId: (state, action) => {
      if (state.smartTrapFilterIds.includes(action.payload)) {
        state.smartTrapFilterIds = state.smartTrapFilterIds.filter(id => id !== action.payload)
      } else {
        state.smartTrapFilterIds = [...state.smartTrapFilterIds, action.payload]
      }
    },
    toggleActiveExtraLayers: (state, action) => {
      if (state.activeExtraLayers.includes(action.payload)) {
        state.activeExtraLayers = state.activeExtraLayers.filter(layer => layer !== action.payload)
      } else {
        state.activeExtraLayers = [...state.activeExtraLayers, action.payload]
      }
    },
    setSmartTrapBufferInMeters: (state, action) => {
      state.smartTrapBufferInMeters = action.payload
    },
    setGridSpacingInKilometers: (state, action) => {
      state.gridSpacingInKilometers = action.payload
    },
  },
})

export const {
  setActiveProject,
  setSourceActiveNames,
  setEnvironmentActiveTypeIds,
  setBreedingSiteActiveTypeIds,
  toggleSmartTrapFilterId,
  toggleActiveExtraLayers,
  setSmartTrapBufferInMeters,
  setGridSpacingInKilometers,
} = login.actions

export default login.reducer
